/**
 * 浏览器 Token 与开发代理认证 — standalone 模块。
 *
 * 本文件被标记为 standalone，表示它**不依赖** request 层的重模块（拦截器、store 等），
 * 仅依赖叶子节点 `@/constants/storage-key`，因此可被任意目录安全引用，不会引发循环依赖。
 *
 * 跨目录引用方：
 *   - `@/request/interceptors` — 请求拦截器注入 Authorization header
 *   - `@/store/user` — 用户状态初始化时预取 token
 *   - `@/service/project-timezone` — 判断认证来源并为独立请求携带浏览器 token
 */
import { USER_TOKEN_KEY } from '@/constants/storage-key';

/** 从 localStorage 获取当前用户的登录 Token */
export const getAuthToken = (): string | null => localStorage.getItem(USER_TOKEN_KEY);

/** 只有开发构建实际访问本站代理时，才允许依赖服务端注入认证。 */
export function canUseDevProxyAuthentication(baseURL: string): boolean {
  if (!import.meta.env.DEV || typeof __DEV_API_PROXY_HAS_AUTH__ === 'undefined'
    || !__DEV_API_PROXY_HAS_AUTH__ || typeof __DEV_API_PROXY_PREFIX__ === 'undefined'
    || !__DEV_API_PROXY_PREFIX__) return false;
  const url = new URL(baseURL, location.origin);
  return url.origin === location.origin
    && url.pathname === `${__DEV_API_PROXY_PREFIX__}/`;
}
